import { backToGuideMessagingFromSearch } from './GuideMessagingModal';

const MessageSearch = () => {
    backToGuideMessagingFromSearch();
    return null;
};

export default MessageSearch;
